import React from "react";
import { Box, CircularProgress } from "@mui/material";
export default function LoadingSpinner() {
  return (
    <Box sx={{ display: "grid", placeItems: "center", py: 6 }}>
      <CircularProgress />
    </Box>
  );
}
